import axiosService from '@/components/Utilities/axiosService';
import {useAuth} from '@clerk/nextjs';
import Link from "next/link";

import "venobox/dist/venobox.min.css";
import {useEffect, useState} from "react";

const Home = () => {
    const [userCount, setUserCount] = useState(0); // Default count set to 1337
    const [username, setUsername] = useState();
    const {getToken} = useAuth()

    useEffect(() => {
        const fetchStatsUserCount = async () => {
            console.log('getAuth', await getToken());
            try {
                const response = await axiosService.post("/stats/GetUserCount", {});
                console.debug("GetUserCount", response);
                if (response.data >= 1000) {
                    setUserCount(response.data);
                }
            } catch (error) {
                // Do Nothing
                console.error(error);
            }
        }

        const getUsersName = async () => {
            if (username) return; // Prevent multiple calls if username is already set

            try {
                const response = await axiosService.post('/auth/login', {});
                setUsername(response.data);
            } catch (error) {
                // Do Nothing
                console.error(error);
            }
        }

        fetchStatsUserCount();
        getUsersName();
    }, []); // Empty dependency array to run only once on mount

    return (
        <>
            <div
                className="slider-area slider-style-1 variation-default slider-bg-image bg-banner1"
                data-black-overlay="1"
            >
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="inner text-center mt--60">
                                <h1 className="title display-one">
                                    {username ? <>Welcome Back {username}! <br/></> : null}
                                    Unlock The Power Of <br/>
                                    <span className="theme-gradient">Resume Lint</span> With <br/>
                                    <span className="color-off">AI</span>
                                </h1>
                                <p className="b1 desc-text">
                                    Elevate your job application game!
                                    {userCount ?
                                        <><strong>{userCount.toLocaleString()}</strong> other users have already
                                            enhanced their resumes.</>
                                        : <><br/>Other users have already enhanced their resumes.</>}
                                    Why wait?
                                </p>
                                <div className="button-group">
                                    <Link
                                        className="btn-default bg-light-gradient btn-large"
                                        href="/resume-analysis"
                                    >
                                        <div className="has-bg-light"></div>
                                        <span>🫵 Unlock Your Potential! 🫵</span>
                                    </Link>
                                </div>
                                <p className="color-gray mt--5">💳 No credit card required!</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Home;